<template>
  <div class="container">
    <div class="row">
      <div id="column-left" class="col-sm-3 hidden-xs column-left">
        <div class="banner">
          <div class="item">
            <a href="#"
              ><img
                src="../assets/image/banners/LeftBanner.jpg"
                alt="Left Banner"
                class="img-responsive"
                style="width:100%"
            /></a>
          </div>
        </div>

        <div class="column-block">
          <div id="basket-complementary-products"></div>
        </div>
      </div>
      <div class="col-sm-9" id="content">
        <h1>Shopping Cart</h1>
        <p v-if="!cartData.length" style="font-size:15px;">
          Your Shopping Cart is empty.
        </p>
        <div v-else>
          <form enctype="multipart/form-data" method="post" action="#">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <td class="text-center">Image</td>
                    <td class="text-left">Product Name</td>
                    <td class="text-left">Brand</td>
                    <td class="text-left">Quantity</td>
                    <td class="text-right">Unit Price</td>
                    <td class="text-right">Total</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in cartData" :key="index">
                    <td class="text-center">
                      <a :href="'#/product/' + product.id"
                        ><img
                          class="img-thumbnail"
                          :title="product.name"
                          :alt="product.name"
                          :src="product.image[0]"
                          style="width:50px;height:59px;"
                      /></a>
                    </td>
                    <td class="text-left">
                      <a :href="'#/product/' + product.id">{{
                        $options.filters.limit(product.name, 50)
                      }}</a>
                    </td>
                    <td class="text-left">{{ product.brand }}</td>
                    <td class="text-left">{{ product.quantity }}</td>
                    <td class="text-right">
                      ${{ product.price | numeral(0, 0) }}
                    </td>
                    <td class="text-right">
                      ${{ (product.price * product.quantity) | numeral(0, 0) }}
                    </td>
                    <td>
                      <div
                        style="max-width: 200px;"
                        class="input-group btn-block"
                      >
                        <span class="input-group-btn">
                          <button
                            class="btn btn-danger"
                            title=""
                            data-toggle="tooltip"
                            type="button"
                            data-original-title="Remove"
                            @click="removeCart(product)"
                          >
                            <i class="fa fa-times-circle"></i>
                          </button>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
          <br />
          <div class="row">
            <div class="col-sm-4 col-sm-offset-8">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td class="text-right"><strong>Total:</strong></td>
                    <td class="text-right">
                      ${{ totalPrice | numeral(0, 0) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="buttons">
          <div class="pull-left">
            <a class="btn btn-default" href="#/">Continue Shopping</a>
          </div>
          <div class="pull-right" v-if="cartData.length">
            <a class="btn btn-primary" href="#/checkout">Checkout</a>
          </div>
        </div>

        <div id="last-minute-offers"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BestSellers from "../components/product/BestSellers.vue";
import Latest from "../components/product/Latest.vue";
import Specials from "../components/product/Specials.vue";

import setCart from '../mixins/setCart';

export default {
  mixins: [setCart],
  components: {
    BestSellers,
    Latest,
    Specials
  },
  data() {
    return {
      cartData: JSON.parse(localStorage.getItem("basket")) || [],
      totalPrice: 0,
      deviceId: ""
    };
  },
  methods: {
    removeCart(data) {
      const productId = data.id;
      const index = this.cartData.findIndex(function(o) {
        return o.id === productId;
      });
      if (index !== -1) {
        this.cartData.splice(index, 1);
      }
      localStorage.setItem("basket", JSON.stringify(this.cartData));
      this.calcTotalPrice();

      Segmentify("basket:remove", {
        productId: data.id,
        quantity: parseInt(data.quantity),
        price: parseInt(data.price)
      });
      /*dengage("sendDeviceEvent", "user_events", {
        event_type: "remove_basket",
        product_id: data.id,
        quantity: parseInt(data.quantity)
      });*/
      /*dataLayer.push({
        event: 'dengage_event',
        dengage_table_name: 'user_events',
        dengage_event_data: {
          event_type: "remove_basket",
          product_id: data.id,
          quantity: parseInt(data.quantity)
        }
      });*/
      dengage('ec:removeFromCart', {
        product_id: data.id,
        product_variant_id: '1',
        quantity: parseInt(data.quantity),
        unit_price: data.price,
        discounted_price: data.price,
        // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
        cartItems: this.cartData.map(b => {
          return {
              product_id: b.id,
              product_variant_id: '1',
              quantity: b.quantity,
              unit_price: b.price,
              discounted_price: b.price,
              // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
          };
        }),
      });

      this.setCartForDengage();
      //collector.removeFromBasket(data.id, 1, parseInt(data.quantity), localStorage.getItem('basket_id'), localStorage.getItem('contact_key'));
    },
    calcTotalPrice() {
      var sum = 0;
      this.cartData.forEach(value => {
        value.price = value.price.replace(/[ ,.]/g, "");
        sum += parseInt(value.price) * value.quantity;
      });

      this.totalPrice = sum;
    }
  },
  created() {
    this.calcTotalPrice();

    var $this = this;
    
    dengage("getContactKey", function(contact_key) {
      const basketProducts = $this.cartData.map(c => {
        return {
          productId: c.id,
          quantity: c.quantity,
          price: parseInt(c.price),
          currency: c.currency
        };
      });

      var sum = 0;
      basketProducts.forEach(value => {
        value.price = value.price;
        sum += parseInt(value.price) * value.quantity;
      });

      window.sgfLayer = {
        page: {
          pageUrl: "https://showcase.dengage.com/#/cart/",
          category: "Cart Page"
        },
        checkout: {
          step: "basket",
          totalPrice: sum,
          currency: "USD",
          cartUrl: "https://showcase.dengage.com/#/cart",
          products: basketProducts
        }
      };
      if (contact_key) {
        window.sgfLayer.common = {
          userId: contact_key
        };
      } else {
        dengage("getDeviceId", function(device_id) {
          window.sgfLayer.common = {
            userId: device_id
          };
        });
      }
    });


    /*dengage("sendDeviceEvent", "user_events", {
      event_type: "page_view",
      page_url: window.location.href,
      page_type: "basket",
      page_title: "Basket Page"
    });*/
    /*dataLayer.push({
      event: 'dengage_event',
      dengage_table_name: 'user_events',
      dengage_event_data: {
        event_type: "page_view",
        page_url: window.location.href,
        page_type: "basket",
        page_title: "Basket Page"
      }
    });*/
    dengage('ec:viewCart', {
      // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
      cartItems: this.cartData.map(b => {
        return {
          product_id: b.id,
          product_variant_id: '1',
          quantity: b.quantity,
          unit_price: b.price,
          discounted_price: b.price,
          // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
        };
      }),
    });



    var basketItems = this.cartData.map(p => ({
      productId: p.id,
      variantId: 1,
      quantity: +p.quantity,
      price: +p.price,
      currency: p.currency,
    }));
    var totalPrice = this.cartData.reduce((acc, p) => {
      var price = +p.price;
      return acc + price;
    }, 0);
    //collector.basketPage(basketItems, totalPrice, localStorage.getItem('basket_id'), localStorage.getItem('contact_key'));
  },
  mounted() {
    dengage('setNavigation', {name: 'cart'});
    $(this.$refs.relatedSlidertab).owlCarousel({
      items: 4,
      navigation: true,
      pagination: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: false,
      itemsMobile: [479, 1]
    });
    var totalQ = this.cartData.reduce((acc, p) => {
      var price = +p.quantity;
      return acc + price;
    }, 0);
    var totalPrice = this.cartData.reduce((acc, p) => {
      var price = +(p.price*p.quantity);
      return acc + price;
    }, 0);
      var a = {
        pageName: "cart-page",
        pageType: "cart",
        basketAmount: totalPrice,
        basketCount: totalQ
      }
      dataLayer.push(a);
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Cart.vue